module.exports = __webpack_public_path__ + "img/Switch-sort-desc.da208855.svg";